/**
 * Strategy for Standard Search without Condition Tabs
 * Fetches page results and unified inventory results in parallel
 */
export async function standardWithoutConditionTabsStrategy({
	query,
	getPageResults,
	getInventoryResults
}) {
	const [pageSearchResponseResult, singleInventorySearchResponse] =
		await Promise.all([getPageResults(query), getInventoryResults(query)]);

	return {
		inventorySearchResponse: singleInventorySearchResponse,
		pageSearchResponse: pageSearchResponseResult
	};
}
